import { createRoutineCreator } from 'redux-saga-routines';
//////////////////////////////////////////////////

const createLoaderRoutine = createRoutineCreator(['SHOW', 'HIDE']);

export const loaderRoutine = createLoaderRoutine('LOADER');
